import React from "react";
import ReactPlayer from "react-player";

const Player = ({ url }) => {
	return <ReactPlayer controls url={url} />;
};

export default Player;
